// Auditoria A1: busca e filtros da lista de membros. Função pura, sem chamar o servidor.

export type FiltroDePapel = 'todos' | 'owner' | 'admin' | 'member';
export type FiltroDeStatus = 'todos' | 'ativo' | 'pendente' | 'inativo';

interface MembroFiltravel {
  name: string | null;
  email: string;
  role: string;
  active: boolean;
  is_pending: boolean;
}

export function statusDoMembro(m: Pick<MembroFiltravel, 'active' | 'is_pending'>): Exclude<FiltroDeStatus, 'todos'> {
  if (m.is_pending) return 'pendente';
  return m.active ? 'ativo' : 'inativo';
}

/** Tira acento e caixa, para "joao" achar "João". */
export function normalizarBusca(texto: string): string {
  return texto.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
}

export function filtrarMembros<T extends MembroFiltravel>(
  membros: T[],
  filtros: { busca: string; papel: FiltroDePapel; status: FiltroDeStatus }
): T[] {
  const termo = normalizarBusca(filtros.busca);
  return membros.filter((m) => {
    if (filtros.papel !== 'todos' && m.role !== filtros.papel) return false;
    if (filtros.status !== 'todos' && statusDoMembro(m) !== filtros.status) return false;
    if (!termo) return true;
    return normalizarBusca(`${m.name ?? ''} ${m.email}`).includes(termo);
  });
}
